import styled from 'styled-components';
import { Stack } from 'components/Stack';

export const Container = styled(Stack)`
  height: 100%;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;
